export default __webpack_public_path__ + "static/media/ic_kuwait.4219ab4a.svg";